package com.essntl.features.crm.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.contact.ui.ContactNavigation
import com.essntl.features.crm.domain.model.ContactOrganizationModel
import com.essntl.features.crm.ui.CRMNavigation
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsNavigation
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ContactOrganizationItem(
    contactOrganization: ContactOrganizationModel,
    onNavigation: (CRMNavigation) -> Unit,
    showDivider: Boolean,
    searchText: String,
    modifier: Modifier = Modifier,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val isPressed by interactionSource.collectIsPressedAsState()

    Column(
        modifier = modifier,
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier =
                Modifier
                    .background(
                        when {
                            isPressed ->
                                MaterialTheme.esColorScheme.tintedPressed

                            isHovered ->
                                MaterialTheme.esColorScheme.tintedHover

                            else ->
                                Color.Transparent
                        },
                    )
                    .focusProperties { canFocus = false }
                    .padding(
                        vertical = EsConstants.ListRowVerticalPadding/2,
                        horizontal = EsConstants.ListRowHorizontalPadding,
                    )
                    .height(EsConstants.ListRowItemHeight / 2)
                    .clickable(
                        interactionSource = interactionSource,
                        indication = null,
                        onClick = {
                            onNavigation(
                                CRMNavigation.EditContact(
                                    contactOrganization.id,
                                ),
                            )
                        },
                    ),

        ) {
            Box(
                contentAlignment = Alignment.CenterStart,
                modifier =
                    Modifier
                        .weight(4f)
                        .fillMaxHeight()
                        .padding(start = 5f.spacing),
            ) {
                SelectionContainer {
                    SearchHighlightedText(
                        text = contactOrganization.name,
                        query = searchText,
                        textStyle = MaterialTheme.esTypography.p2Medium14,
                        textColor = MaterialTheme.esColorScheme.textPrimary,
                    )
                }
            }

            Box(
                contentAlignment = Alignment.CenterStart,
                modifier =
                    Modifier
                        .weight(2f)
                        .fillMaxHeight(),
            ) {
                Text(
                    text = contactOrganization.email.orEmpty(),
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.p2Medium14,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }

            Box(
                contentAlignment = Alignment.CenterStart,
                modifier =
                    Modifier
                        .weight(2f)
                        .fillMaxHeight(),
            ) {
                Text(
                    text = "-",
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.p2Medium14,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }

        if (showDivider)
            HorizontalDivider(
                thickness = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
            )
    }
}